/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ReviewStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REQUESTED_CHANGES = 'REQUESTED_CHANGES',
}
